import React from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "./ErrorBoundary";

const DynamicComponentRenderer = ({ componentConfig }) => {
  const selectedRole = useSelector((state) => state.account.selectedRole.value);

  return (
    <>
      {componentConfig.map((config, index) => {
        const { role, component, className } = config;
        if (role && !role.includes(selectedRole) && !role.includes("Both")) {
          return null;
        }

        return (
          <div key={index} className={className || "col-sm-12"}>
            <ErrorBoundary>{component}</ErrorBoundary>
          </div>
        );
      })}
    </>
  );
};

export default DynamicComponentRenderer;
